import { useUncaughtResizeError } from 'hooks/useUncaughtResizeError';
import PaymentsContainer from 'pages/payments/payments-container.component';
import SocialShareContainer from 'pages/social-share/social-share.container';
import ViewMessages from 'pages/view-messages/view-messages.component';
import React, { Suspense } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from './components/spinner/spinner.component';
import usei18nListener from './hooks/usei18nListener';
import ClientContainer from './pages/client/client.container';
import i18nSlice from './redux/i18n/i18n.slice';
import ViewOffers from 'pages/view-offers/view-offers.component';
import AriaPersistentContainer from 'components/sr-alerts/aria-persistent-container/aria-persistent-container.component';
import SrItemRemovedAlert from 'components/sr-alerts/sr-item-removed-alert/sr-item-removed-alert.component';
import SrItemAddedAlert from 'components/sr-alerts/sr-item-added-alert/sr-item-added-alert.component';
import SrCartTotalItemsAlert from 'components/sr-alerts/sr-cart-total-items-alert/sr-cart-total-items-alert.component';
import SrCartSubtotalAlert from 'components/sr-alerts/sr-cart-cart-subtotal/sr-cart-subtotal.component';
import SrCartTotalAlert from 'components/sr-alerts/sr-cart-cart-total/sr-cart-total.component';

function App() {
  const dispatch = useDispatch();
  usei18nListener('languageChanged', lng => {
    dispatch(i18nSlice.actions.localeChanged(lng));
  });

  useUncaughtResizeError();

  return (
    <Suspense fallback={<Spinner />}>
      <ToastContainer role="alert" className="App-ToastContainer" />
      <AriaPersistentContainer>
        <SrItemRemovedAlert />
        <SrItemAddedAlert />
        <SrCartTotalItemsAlert />
        <SrCartSubtotalAlert />
        <SrCartTotalAlert />
      </AriaPersistentContainer>
      <BrowserRouter>
        <Switch>
          <Route exact path="/socialshare/fb">
            <SocialShareContainer />
          </Route>
          <Route exact path="/offers/list">
            <ViewOffers />
          </Route>
          <Route exact path="/messages/list">
            <ViewMessages />
          </Route>
          <Route exact path="/payments/threeds2verification">
            <PaymentsContainer />
          </Route>
          <Route path={['/', '/test']}>
            <ClientContainer />
          </Route>
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
